export const DASHBOARD_TEXT = {
    heading: "Welcome to your Dashboard",
    title: "Samarth academy"
}